<template>
    <div>
        <!-- 电脑端 Footer（H5 下整体等比例缩小显示，见底部 zoom 媒体块） -->
        <div class="footer-desktop">

            <div class="footer-container">
                <div class="footer-content">
                    <!-- 左侧：Logo和导航 -->
                    <div class="footer-left">

                        <div class="footer-nav">
                            

                            <div class="nav-column">
                                <h4 class="nav-title">{{ $t('footer.nav.navigation') }}</h4>
                                <!-- 顺序与头部导航保持一致 -->
                                <ul>
                                    <li><router-link to="/">{{ $t('footer.nav.home') }}</router-link></li>
                                    <li><router-link to="/blog-single-column">{{ $t('about.SimplifiedName') }}</router-link></li>
                                    <li><router-link to="/yantai-ai">{{ $t('about.aiName') }}</router-link></li>
                                    <li><a href="javascript:;" @click="openExternal(collegeUrl)">{{ $t('college') }}</a></li>
                                    <!-- 衍泰WEB3：外链跳转，地址暂未配置（为空时点击不跳转） -->
                                    <li><a href="javascript:;" @click="openExternal(web3Url)">{{ $t('web3') }}</a></li>
                                    <li><router-link to="/about">{{ $t('footer.nav.about') }}</router-link></li>
                                    <li><router-link to="/contact">{{ $t('footer.nav.contact') }}</router-link></li>
                                </ul>
                            </div>

                            <div class="nav-column">
                                <h4 class="nav-title">{{ $t('footer.nav.legal') }}</h4>
                                <ul>
                                    <li><router-link to="/privacy-policy">{{ $t('footer.nav.privacy') }}</router-link>
                                    </li>
                                    <li><router-link to="/terms-condition">{{ $t('footer.nav.terms') }}</router-link>
                                    </li>
                                    <li><router-link to="/risk-disclosure">{{ $t('footer.nav.risk') }}</router-link>
                                    </li>
                                    <li><router-link to="/compliance">{{ $t('footer.nav.compliance') }}</router-link>
                                    </li>
                                </ul>
                            </div>

                            <div class="nav-column">
                                <h4 class="nav-title">{{ $t('footer.nav.followUs') }}</h4>
                                <div class="footer-social-wrapper">
                                    <span><social-links /></span>
                                </div>
                                <h4 class="nav-title footer-contact-title">{{ $t('footer.nav.contact') }}</h4>
                                <div class="footer-contact-row footer-hover-item">
                                    <img class="footer-contact-icon" src="@/assets/images/icons/图标 46.png" alt="">
                                    <span class="contact-email footer-hover-text">client@matrixpower.org</span>
                                </div>
                                <div class="footer-right">
                                    <div class="footer-address footer-hover-item">
                                        <div class="footer-address-row">
                                            <img class="footer-address-icon"
                                                src="@/assets/images/icons/路径 (1).png" alt="">
                                            <p class="footer-address-text footer-hover-text">{{ $t('footer.address') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ========== 三个统计盒子（替换111） ========== -->
                <!-- <div class="content stats-wrapper">
                    <div class="stat-box">
                        <span class="stat-number"><img src="@/assets/images/icons/组 60.png" alt=""></span>
                        <span class="stat-label">SOC 2 Type II</span>
                    </div>
                    <div class="stat-box">
                        <span class="stat-number"><img src="@/assets/images/icons/组 62.png" alt=""></span>
                        <span class="stat-label">MSB Licensed</span>
                    </div>
                    <div class="stat-box">
                        <span class="stat-number"><img src="@/assets/images/icons/组 64.png" alt=""></span>
                        <span class="stat-label">MPC + HSM</span>
                    </div>
                </div> -->
                <!-- ========== 三个统计盒子结束 ========== -->
                <!-- 底部版权和免责 -->
                <div class="footer-bottom">
                    <div class="footer-copyright">
                        <span>{{ $t('footer.copyright') }}</span>
                    </div>
                    <div class="footer-disclaimer">
                        <p class="footer-hover-text">{{ $t('footer.disclaimer.p1') }}</p>
                        <p class="footer-hover-text">{{ $t('footer.disclaimer.p2') }}</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- 移动端 Footer（已由缩放版桌面 footer 取代，保留结构便于回退） -->
        <div class="d-none">

            <div class="copy-right-one ptb--20 bg-color--1">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12 col-sm-12">
                            <div class="copyright-left">
                                <img class="footer-mobile-logo partner-logo" src="@/assets/images/logo/icon_home_logo@3x.png">
                                <span class="footer-mobile-copyright">{{ $t('footer.copyright') }}</span>
                                <ul class="privacy">
                                    <li class="footer-mobile-link">
                                        <router-link to="/terms-condition">{{ $t('terms') }}</router-link>
                                    </li>
                                    <li class="footer-mobile-link">
                                        <router-link to="/privacy-policy">{{ $t('Disclaimers') }}</router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12">
                            <div class="copyright-right">
                                <social-links />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 通用组件 -->
        <div class="mouse-cursor cursor-outer" />
        <div class="mouse-cursor cursor-inner" />

        <img @click="showModal = true" class="customerService" src="@/assets/images/icons/icon_lianxiwomen_kefu@3x.png"
            alt="">
        <back-to-top @click="scrollTop" />

        <SupportModal :is-show="showModal" :close-on-backdrop="true" @close-modal="showModal = false"
            @contact="handleContact" />
    </div>
</template>

<script>
import BackToTop from '@/components/layouts/footer/BackToTop'
import Logo from "@/components/logo/Logo";
import SocialLinks from "@/components/social/SocialLinks";
import SupportModal from './SupportModal.vue';

export default {
    name: 'Footer',
    components: { SocialLinks, Logo, BackToTop, SupportModal },
    props: {
        data: {
            default: null,
        }
    },
    data() {
        return {
            showModal: false,
            custom_url: '',
            // 底部导航外链（与头部保持一致）
            collegeUrl: 'https://study.matrixpower.club/',
            web3Url: ''
        }
    },
    methods: {
        openExternal(url) {
            if (url) {
                window.open(url);
            }
        },
        handleContact(email) {
            this.custom_url = 'http://custom.baoshijians.com/chat/pc?token=2e2b5a639df40066deea84c92984536b&noCanClose=1' + "&nickName=" + email;
            window.open(this.custom_url);
        },
        handleModalClose() {
            this.showModal = false;
            console.log(this.showModal, 1111);
        },
        scrollTop() {
            window.scrollTo(0, 0);
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .social-copyright {
    gap: 50px;
    display: flex;
    justify-content: space-between;
}

// 通用样式
.customerService {
    z-index: 999;
    position: fixed;
    bottom: 100px;
    right: 30px;
    width: 45px;
    cursor: pointer;
}

.pop {
    z-index: 999;
    position: fixed;
    bottom: 50px;
}

// ============ 电脑端 Footer 样式 ============
.footer-desktop {
    background: #0a0e17;
    color: #ffffff;
    padding: 60px 200px 30px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);

    .footer-container {
        max-width: 1400px;
        margin: 0 auto;
        min-height: 430px;
    }

    .footer-content {
        display: flex;
        justify-content: space-between;
        gap: 60px;
        padding-bottom: 40px;
        min-height: 300px;
    }

    // 左侧区域
    .footer-left {
        flex: 1;

        .footer-logo-section {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 40px;

            .footer-logo {
                width: 40px;
                height: 40px;
            }

            .footer-brand {
                font-size: 20px;
                font-weight: 600;
                color: #ffffff;
                letter-spacing: 2px;
            }
        }

        .footer-nav {
            display: flex;
            justify-content: space-between;

            .nav-column {
                .nav-title {
                    font-size: 16px;
                    font-weight: 600;
                    color: #FFFFFF;
                    margin-bottom: 16px;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                }

                ul {
                    list-style: none;
                    padding: 0;
                    margin: 0;

                    li {
                        margin-bottom: 25px;

                        a {
                            color: #86909C;
                            text-decoration: none;
                            font-size: 14px;
                            transition: color 0.3s ease;

                            &:hover {
                                color: #ffffff;
                            }
                        }
                    }
                }

                .contact-email {
                    color: rgba(255, 255, 255, 0.7);
                    font-size: 14px;
                    margin-left: 8px;
                }
            }
        }
    }

// ========== 三个统计盒子样式 ==========
    .stats-wrapper {
        display: flex;
        gap: 20px;
        justify-content: center;
        align-items: center;
        padding: 20px 0;
        height: auto;

        .stat-box {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 135px;
            min-height: 35px;
            border: 1px solid rgba(255, 255, 255, 0.08);
            border-radius: 12px;
            background: rgba(255, 255, 255, 0.03);
            transition: all 0.3s ease;
            cursor: pointer;

            &:hover {
                border-color: rgba(255, 255, 255, 0.25);
                background: rgba(255, 255, 255, 0.08);
                transform: translateY(-2px);
                box-shadow: 0 0 20px rgba(255, 255, 255, 0.2), 0 4px 15px rgba(0, 0, 0, 0.3);
            }

            &:hover .stat-label {
                color: #ffffff;
            }

            .stat-number {
                font-size: 36px;
                font-weight: 700;
                color: #ffffff;
                line-height: 1.2;
            }

            .stat-label {
                font-size: 14px;
                color: rgba(255, 255, 255, 0.5);
                margin-top: 4px;
                margin-left: 8px;
                white-space: nowrap;
                transition: color 0.3s ease;
            }
        }
    }

    // 联系我们和地址悬停效果
    .footer-hover-item {
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .footer-hover-item:hover .footer-hover-text {
        color: #ffffff !important;
    }

    // 免责声明每行单独悬停
    .footer-disclaimer {
        p.footer-hover-text {
            cursor: pointer;
            transition: color 0.3s ease;
        }

        p.footer-hover-text:hover {
            color: #ffffff !important;
        }
    }

    // 右侧区域
    .footer-right {
        min-width: 280px;
        text-align: right;
        margin-top: 20px;

        .certification-badges {
            display: flex;
            gap: 12px;
            justify-content: flex-end;
            margin-bottom: 20px;
            flex-wrap: wrap;

            .badge {
                display: inline-block;
                padding: 6px 16px;
                border: 1px solid rgba(255, 255, 255, 0.15);
                border-radius: 20px;
                font-size: 12px;
                color: rgba(255, 255, 255, 0.6);
                letter-spacing: 0.5px;
                background: rgba(255, 255, 255, 0.04);
            }
        }

        .footer-address {
            p {
                color: rgba(255, 255, 255, 0.5);
                font-size: 13px;
                line-height: 1.6;
                margin: 0;
            }
        }
    }

    // 底部版权和免责
    .footer-bottom {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        padding-bottom: 40px;
        gap: 40px;
        color: #86909C;

        .footer-copyright {
            white-space: nowrap;

            span {
                color: rgba(255, 255, 255, 0.4);
                font-size: 14px;
            }
        }

        .footer-disclaimer {
            text-align: center;
            max-width: 600px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            p {
                color: rgba(255, 255, 255, 0.3);
                font-size: 12px;
                line-height: 1.8;
                margin: 0 0 4px 0;
                transition: color 0.3s ease;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
}

// ============ 响应式调整 ============

@media (min-width: 1920px) {
.footer-desktop {
    background: #0a0e17;
    color: #ffffff;
    padding: 60px 370px 30px;
   
}
}
@media (max-width: 1300px) and (min-width: 992px) {
.footer-desktop {
    background: #0a0e17;
    color: #ffffff;
    padding: 60px 50px 30px;

}
}

@media (max-width: 1200px) and (min-width: 992px) {
    .footer-desktop {
        padding: 50px 0px 30px;

        .footer-content {
            flex-direction: column;
            gap: 40px;
        }

        .footer-right {
            text-align: left;
            min-width: auto;

            .certification-badges {
                justify-content: flex-start;
            }
        }

        .footer-bottom {
            flex-direction: column;
            align-items: flex-start;

            .footer-disclaimer {
                text-align: center;
            }
        }
    }
}

@media (max-width: 992px) and (min-width: 992px) {
    ::v-deep .social-copyright {
    gap: 10px;
    display: flex;
    justify-content: space-between;
}
    .footer-desktop {
        .footer-left {
            .footer-nav {
                gap: 40px;
                flex-wrap: wrap;

                .nav-column {
                    min-width: 120px;
                }
            }
        }

        // 统计盒子响应式
        .stats-wrapper {
            flex-wrap: wrap;
            gap: 12px;

            .stat-box {
                flex: 1;
                min-width: 80px;
                min-height: 70px;
                padding: 14px 20px;

                .stat-number {
                    font-size: 28px;
                }

                .stat-label {
                    font-size: 12px;
                  
                }
            }
        }
    }
}

// ========== 提取的行内样式 ==========
.footer-social-wrapper {
    display: flex;
}

.footer-contact-title {
    margin-top: 30px;
}

.footer-contact-row {
    display: flex;
    align-items: center;

    .footer-contact-icon {
        width: 15px;
        height: 15px;
    }
}

.footer-address-row {
    display: flex;
    align-items: center;

    .footer-address-icon {
        width: 13px;
        height: 15px;
        margin-right: 8px;
    }
}

.footer-address-text {
    text-align: left;
}

// ========== 移动端提取样式 ==========
.footer-mobile-logo {
    width: 10rem;
}

.footer-mobile-copyright {
    white-space: nowrap;
}

.footer-mobile-link {
    white-space: nowrap;
}

/* ========== H5 版权栏适配：允许换行，防止文字溢出 ========== */
@media (max-width: 991px) {
    .copy-right-one .copyright-left {
        flex-wrap: wrap;
        row-gap: 8px;
    }

    .footer-mobile-logo {
        width: 7.5rem;
    }

    .copy-right-one .copyright-left .footer-mobile-copyright {
        white-space: normal;
        font-size: 13px;
    }

    .copy-right-one .copyright-left .privacy {
        flex-wrap: wrap;
        row-gap: 4px;
    }

    .footer-mobile-link {
        white-space: normal;
    }

    .copy-right-one .copyright-left .privacy li a {
        font-size: 13px;
    }
}

/* ========== H5：桌面 footer 等比例缩小（整体缩放，倍率兼顾可读性） ========== */
@media (max-width: 991px) {
    .footer-desktop { zoom: 0.65; }   /* 平板：内部约 1181px 设计宽，三栏不换行 */
}

@media (max-width: 480px) {
    /* 手机：压缩左右留白（200→40）换取更大字号，内部约 682px 设计宽，三栏仍放得下 */
    .footer-desktop {
        zoom: 0.55;
        padding: 30px 40px 24px;
    }
}

@media (max-width: 360px) {
    .footer-desktop { zoom: 0.4; }   /* 超窄屏兜底 */
}
</style>